/** @jsxImportSource @emotion/react */
/**
 * Компонент ячейки с чекбоксом для таблицы посадок
 * Расширенная кликабельная зона с hover-эффектом
 */
import React from 'react';
import { css } from '@emotion/react';

interface CheckboxCellProps {
  checked: boolean;
  recordId: string | number;
  selectedRowKeys: React.Key[];
  onChange: (selectedRowKeys: React.Key[], selectedRows: any[]) => void;
  children: React.ReactNode;
}

const CheckboxCell: React.FC<CheckboxCellProps> = ({
  checked,
  recordId,
  selectedRowKeys,
  onChange,
  children,
}) => {
  const handleCheckboxAreaClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    const recordKey = String(recordId);
    const newSelectedKeys = checked
      ? selectedRowKeys.filter((key) => String(key) !== recordKey)
      : [...selectedRowKeys, recordKey];
    onChange(newSelectedKeys, []);
  };

  return (
    <div
      onClick={handleCheckboxAreaClick}
      css={css({
        padding: '8px',
        margin: '-8px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        borderRadius: '4px',
        transition: 'background-color 0.2s',
        '&:hover': {
          backgroundColor: 'rgba(0, 0, 0, 0.04)',
        },
      })}
    >
      {children}
    </div>
  );
};

export default CheckboxCell;
